export const SET_WORDBANK = 'setWordbank';
export const SET_CURRENT_CATEGORY = 'setCurrentCategory';
export const RESET_ACTIVE_CATEGORY = 'resetActiveCategory';
export const TOGGLE_EDIT_MODE = 'toggleEditMode';
export const SET_FILTER_MODE = 'setFilterMode';
export const FILTER_CATEGORY = 'filterCategory';
export const APPEND_TO_ROOT_CATEGORY = 'appendToRootCategory';
export const APPEND_SUB_CATEGORY = 'appendSubCategory';
export const ADD_TO_CURRENT_CATEGORY = 'addToCurrentCategory';
export const CANCEL_ADD_FROM_CURRENT_CATEGORY = 'cancelAddFromCurrentCategory';
export const REMOVE_CURRENT_CATEGORY = 'removeCurrentCategory';
export const UPDATE_WORDBANK_IN_CATEGORY = 'updateWordbankInCategory';
export const ADD_WORDBANK_TO_CATEGORY = 'addWordbankToCategory';
export const DELETE_WORDBANK_FROM_CATEGORY = 'deleteWordbankFromCategory';

export const CLOSE_ALL_CHILD = 'closeAllChild';
export const STORE_LAST_CATEGORY_STATUS = 'storeLastCategoryStatus';
export const RECOVER_LAST_ACTIVE_CATEGORY = 'recoverLastActiveCategory';
export const TOGGLE_MOVETO_MODE = 'toggleMoveToMode';
export const RESET_ACTIVE_ID = 'resetActiveId';

export const SET_HAS_NEW_CATEGORY = 'setHasNewCategory';



// WEBPACK FOOTER //
// ./src/modules/Wordbank/_store/mutations_type.js